module.exports = __webpack_public_path__ + "img/typo-left-handed.f10043d3.svg";